// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2qJ6r","validationTips":"StatementDescriptor_validationTips__Mhc30"};